import React, { useState } from "react";
import { capitalize } from "lodash";
import { formatPhoneNumber, isValidPhoneNumber } from "react-phone-number-input";
import { CallDeclined, CallInProgress } from "../../../../icons/js/CallIcons";
import DoubleArrowDown from "../../../../icons/js/DoubleArrowDown";
import ExtensionCallIcon from "../../../../icons/ExtensionCallIcon";
import AudioComponent from "../audioComponent";
import TranscriptionView from "./TranscriptionView";
import EmployeeCallDetailSummary from "../../../callDashboard/EmployeeCallDetailSummary";
import useLang from "../../../../hooks/useLang";
import { formatDurationToReadable } from "../../../../utils/dateTimes";
import { AUDIO_CALL_STATUS } from "../../../../constant/AudioCallConstans";

const formatPhone = phoneNumber => {
  if (!isValidPhoneNumber(phoneNumber)) return phoneNumber;
  return formatPhoneNumber(phoneNumber);
};

const CallDetailsCard = ({ call, recordingUrl, callSummary, overrideClassName }) => {
  const [lang] = useLang();

  const [isTranscribeVisible, setIsTranscribeVisible] = useState(false);
  const [isCallDetailVisible, setIsCallDetailVisible] = useState(false);

  // Icon mapping object for different call outcomes
  const callIconMapping = {
    [AUDIO_CALL_STATUS.VOICEMAIL]: <CallInProgress />,
    [AUDIO_CALL_STATUS.NORMAL]: <CallInProgress />,
    [AUDIO_CALL_STATUS.MISSED]: <CallDeclined />,
  };

  const CallIcon = () => {
    return callIconMapping[call?.eaiCallerOutcome] || <CallInProgress />;
  };

  const handleToggleTranscribe = () => {
    setIsTranscribeVisible(!isTranscribeVisible);
  };

  return (
    <>
      <div className={`flex-col-centered bg-white ${overrideClassName}`}>
        <div className="p-3 flex-row-centered gap-4 w-full">
          <div>{call === null ? <CallDeclined /> : <CallIcon />}</div>
          <div className="flex-col-centered gap-1">
            <span className="sm-600 text-grey-700">
              {capitalize(call?.direction || "")} {lang.callActivityCenter.call}{" "}
              {call?.direction === "OUTBOUND" &&
              call?.callInitiationRequest?.callInitiationType === "CLICK_TO_CALL" ? (
                <ExtensionCallIcon />
              ) : null}
            </span>
            <span className="xs-400 text-grey-700">
              {lang.callActivityCenter.caller}: {call?.fromName} (
              {formatPhone(call?.fromNumber || "")})
            </span>
            <span className="xs-400 text-grey-700">
              {lang.callActivityCenter.callee}: {call?.toName} ({formatPhone(call?.toNumber || "")})
            </span>
            <span className="xs-400 text-grey-700">
              {lang.callActivityCenter.duration}: {formatDurationToReadable(call?.durationSeconds)}
            </span>
            <span className="xs-400 text-grey-700">
              {lang.callActivityCenter.callTranscription}:{" "}
              <span
                className="font-[600] text-blue-600 cursor-pointer"
                onClick={() => setIsCallDetailVisible(true)}
              >
                Click Here
              </span>
            </span>
          </div>
        </div>
        {recordingUrl && (
          <div className="px-4 pb-3 w-full">
            <AudioComponent src={recordingUrl} />
          </div>
        )}
        <div className="bg-warning-100 rounded-b-[10px] flex-row-centered justify-center px-3 py-1 w-full">
          <span
            onClick={handleToggleTranscribe}
            className="xs-400 text-grey-900 flex-row-centered justify-center gap-1 cursor-pointer"
          >
            {lang.callActivityCenter.callSummary}{" "}
            <DoubleArrowDown
              color="#0F172A"
              className={`${isTranscribeVisible ? "rotate-180" : ""} transition-all duration-300`}
            />
          </span>
        </div>
      </div>
      {isTranscribeVisible && (
        <div className="mt-2">
          <TranscriptionView
            summary={callSummary}
            onSummaryTranscriptionClick={() => {
              // Your click handler logic here
              setIsCallDetailVisible(true);
            }}
          />
        </div>
      )}
      {isCallDetailVisible && (
        <EmployeeCallDetailSummary
          visible={isCallDetailVisible}
          callDetails={call}
          onClose={() => setIsCallDetailVisible(false)}
        />
      )}
    </>
  );
};

export default CallDetailsCard;
